let children = [];
//------------ ADMINISTRACION -------------------------
children.push({
  path: "/sistemas/inventario",
  name: "TIC_INVENTORY",
  component: () =>
    import("@/views/InformationTechnology/Inventory/Inventory.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Sistemas", disabled: true },
      { text: "Inventario", href: "/sistemas/inventario" },
    ],
  },
});
children.push({
  path: "/sistemas/asignacion",
  name: "TIC_ASSIGNAMENT",
  component: () =>
    import(
      "@/views/InformationTechnology/AssignamentInventory/AssignamentNew.vue"
    ),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Sistemas", disabled: true },
      { text: "Asignación Equipos", href: "/sistemas/asignacion" },
    ],
  },
});

children.push({
  path: "/sistemas/equipment",
  name: "TIC_EQUIPMENT",
  component: () =>
    import("@/views/InformationTechnology/Equipment/Equipment.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Sistemas", disabled: true },
      { text: "Equipos TI", href: "/sistemas/equipment" },
    ],
  },
});

children.push({
  path: "/sistemas/unsubscribe",
  name: "TIC_UNSUBSCRIBE",
  component: () => import("@/views/InformationTechnology/Unsubscribe.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Sistemas", disabled: true },
      { text: "Dar de Baja", href: "/sistemas/unsubscribe" },
    ],
  },
});

children.push({
  path: "/sistemas/planes-telefonia",
  name: "TIC_PHONE_PLAN",
  component: () =>
    import("@/views/InformationTechnology/Inventory/PhonePlan.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Sistemas", disabled: true },
      { text: "Planes de Telefonía", href: "/sistemas/planes-telefonia" },
    ],
  },
});

children.push({
  path: "/sistemas/componentes",
  name: "TIC_COMPONET",
  component: () =>
    import("@/views/InformationTechnology/Inventory/Component.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Sistemas", disabled: true },
      { text: "Componentes", href: "/sistemas/componentes" },
    ],
  },
});
children.push({
  path: "/sistemas/licencias",
  name: "TIC_LICENSE",
  component: () =>
    import("@/views/InformationTechnology/Inventory/License.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Sistemas", disabled: true },
      { text: "Licencias", href: "/sistemas/licencias" },
    ],
  },
});
children.push({
  path: "/sistemas/configuracion",
  name: "TIC_CONFIGURATION",
  component: () =>
    import(
      "@/views/InformationTechnology/Configuration/RequestAdministration.vue"
    ),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Sistemas", disabled: true },
      { text: "Configuracion", href: "/sistemas/configuracion" },
    ],
  },
});
children.push({
  path: "/sistemas/tickets",
  name: "TIC_TICKET",
  component: () =>
    import("@/views/InformationTechnology/Management/Soporte.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Sistemas", disabled: true },
      { text: "Tickets", href: "/sistemas/tickets" },
    ],
  },
});

children.push({
  path: "/sistemas/scannerequipmentassignment",
  name: "TIC_SCANNER_EQUIPMENT_ASSIGNMENT",
  component: () =>
    import(
      "@/views/InformationTechnology/ScannerEquipmentAssignment/ScannerEquipmentAssignment.vue"
    ),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Sistemas", disabled: true },
      {
        text: "Scanner Asignación Equipos",
        href: "/sistemas/scannerequipmentassignment",
      },
    ],
  },
});

children.push({
  path: "/sistemas/equipmentassignment",
  name: "ITE_EQUIPMENT_ASSIGNMENT",
  component: () =>
    import(
      "@/views/InformationTechnology/EquipmentAssignment/EquipmentAssignment.vue"
    ),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Sistemas", disabled: true },
      {
        text: "Scanner Asignación Equipos",
        href: "/sistemas/equipmentassignment",
      },
    ],
  },
});

children.push({
  path: "/sistemas/helpdesk",
  name: "ITE_HELP_DESK",
  component: () =>
    import("@/views/InformationTechnology/HelpDesk/HelpDesk.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Sistemas", disabled: true },
      { text: "Help Desk", href: "/sistemas/helpdesk" },
    ],
  },
});

children.push({
  path: "/sistemas/tareas",
  name: "TIC_TASK",
  component: () => import("@/views/InformationTechnology/Task/Task.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "TI", disabled: true },
      { text: "Recordatorios", href: "/sistemas/tareas" },
    ],
  },
});

children.push({
  path: "/sistemas/tareasProyect",
  name: "TIC_TASKPROYECT",
  component: () =>
    import("@/views/InformationTechnology/TaskProyect/TaskProyect.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "TI", disabled: true },
      { text: "Recordatorios", href: "/sistemas/tareasProyect" },
    ],
  },
});

// configuracion marca de componente David Domador
children.push({
  path: "/sistemas/mantenimiento/marca_componente",
  name: "TIC_COMPONENTS_BRAND",
  component: () =>
    import("@/views/InformationTechnology/Maintenance/ComponentsBrands.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Sistemas", disabled: true },
      {
        text: "Marca de componente",
        href: "/sistemas/mantenimiento/marca_componente",
      },
    ],
  },
});

children.push({
  path: "/sistemas/equipment_maintenance",
  name: "TIC_EQUIPMENT_MAINTENANCE",
  component: () => import("@/views/InformationTechnology/Maintenance/EquipmentMaintenanceV2.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Sistemas", disabled: true },
      { text: "Programa Mantenimientos TI", href: "/sistemas/equipment_maintenance" },
    ],
  },
});

children.push({
  path: "/sistemas/equipment_maintenance_tasks",
  name: "TIC_EQUIPMENT_MAINTENANCE_TASKS",
  component: () => import("@/views/InformationTechnology/Maintenance/EquipmentMaintenanceTasksV2.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Sistemas", disabled: true },
      { text: "Mantenimientos TI", href: "/sistemas/equipment_maintenance" },
    ],
  },
});

children.push({
  path: module + "/controltareas",
  path: "/sistemas/controltareas",
  name: "TIC_TASK_CONTROL",
  component: () =>
    import("@/views/InformationTechnology/ControlTask/ControlTask.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Sistemas", disabled: true },
      { text: "Control Tareas", href: "/sistemas/controltareas" },
    ],
  },
});

children.push({
  path: "/sistemas/SunDrive",
  name: "SNFILEDRVE",
  component: () =>
    import("@/views/InformationTechnology/SunDrive/sunDrive.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Sistemas", disabled: true },
      { text: "SunDrive", href: "/sistemas/SunDrive" },
    ],
  },
});

children.push({
  path: "/sistemas/dashboard",
  name: "TIC_DASHBOARD",
  component: () =>
    import("@/views/InformationTechnology/Dashboard/Dashboard.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Sistemas", disabled: true },
      { text: "Dashboard", href: "/sistemas/dashboard" },
    ],
  },
});

children.push({
  path: "/sistemas/solicitudrequerimientos",
  name: "TIC_REQUIREMENTSREQUEST",
  component: () => import("@/views/InformationTechnology/RequirementsRequest/RequirementsRequest.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "TI", disabled: true },
      { text: "Recordatorios", href: "/sistemas/solicitudrequerimientos" },
    ],
  },
});

children.push({
  path: "/sistemas/backlog",
  name: "TIC_BACKLOG",
  component: () => import("@/views/InformationTechnology/Task/Sprints/Backlog.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "TI", disabled: true },
      { text: "Backlog", href: "/sistemas/backlog" },
    ],
  },
});

children.push({
  path: "/sistemas/kanban",
  name: "TIC_TASK_KANBAN",
  component: () => import("@/views/InformationTechnology/Task/TaskKanban.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "TI", disabled: true },
      { text: "Recordatorios", href: "/sistemas/kanban" },
    ],
  },
});

children.push({
  path: "/sistemas/requerimiento",
  name: "TIC_REQUIREMENT",
  component: () => import("@/views/InformationTechnology/Requirement/Requirement.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "TI", disabled: true },
      { text: "Solicitud Requerimientos", href: "/sistemas/requerimiento" },
    ],
  },
});

children.push({
  path: "/sistemas/priorizacion",
  name: "TIC_PRIORITIZATION",
  component: () => import("@/views/InformationTechnology/Requirement/Prioritization.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "TI", disabled: true },
      { text: "Priorización Requerimientos", href: "/sistemas/priorizacion" },
    ],
  },
});

children.push({
  path: "/sistemas/refinamiento",
  name: "TIC_REFINEMENT",
  component: () => import("@/views/InformationTechnology/Requirement/Refinement.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "TI", disabled: true },
      { text: "Refinamiento Requerimientos", href: "/sistemas/refinamiento" },
    ],
  },
});

children.push({
  path: "/sistemas/estimacion",
  name: "TIC_ESTIMATION",
  component: () => import("@/views/InformationTechnology/Requirement/Estimation.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "TI", disabled: true },
      { text: "Estimación Requerimientos", href: "/sistemas/estimacion" },
    ],
  },
});

children.push({
  path: "/sistemas/mis-estimaciones",
  name: "TIC_MY_ESTIMATIONS",
  component: () => import("@/views/InformationTechnology/Requirement/MyEstimations.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "TI", disabled: true },
      { text: "Mis Estimaciones", href: "/sistemas/mis-estimaciones" },
    ],
  },
});

children.push({
  path: "/sistemas/backlog-ejecucion",
  name: "TIC_SPRINT_BACKLOG",
  component: () => import("@/views/InformationTechnology/Requirement/SprintBacklog.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "TI", disabled: true },
      { text: "Backlog Ejecución TI", href: "/sistemas/backlog-ejecucion" },
    ],
  },
});

children.push({
  path: "/sistemas/tablero-kanban",
  name: "TIC_KANBAN_BOARD",
  component: () => import("@/views/InformationTechnology/Requirement/KanbanBoard.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "TI", disabled: true },
      { text: "Tablero Kanban TI", href: "/sistemas/tablero-kanban" },
    ],
  },
});

children.push({
  path: "/sistemas/dashboard-desarrollo",
  name: "TIC_DASHBOARD_SOFTWARE_DEV",
  component: () => import("@/views/InformationTechnology/Requirement/DashboardSoftwareDev.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "TI", disabled: true },
      { text: "Dashboard Desarrollo TI", href: "/sistemas/dashboard-desarrollo" },
    ],
  },
});

export { children };

